<nz-page-header class="skiptranslate" (nzBack)="goHome()" nzBackIcon [nzGhost]="false">
  <nz-page-header-title class="skiptranslate">{{
    'PARTS.PARTS_SEARCH' | translate
  }}</nz-page-header-title>
  <nz-page-header-content>
    <section class="section header skiptranslate">
      <p>
        {{ 'PARTS.P_1' | translate }}
        <br />
        {{ 'PARTS.P_2' | translate }}
      </p>
      <p>
        ZZT260 ALLION
        <br />
        ZVW30 PRIUS
      </p>
      <p>
        <span>{{ 'PARTS.VIN' | translate }}:</span><br />
        <input nz-input nzSize="large" [(ngModel)]="vin" />
      </p>
    </section>

    <section class="section parts skiptranslate">
      <nz-tabset nzSize="large">
        <nz-tab *ngFor="let category of categories" [nzTitle]="category">
          <div nz-row>
            <div
              *ngFor="let part of parts[category]"
              nz-col
              [nzXl]="6"
              [nzLg]="8"
              [nzMd]="12"
              [nzSm]="12"
              [nzXs]="24"
            >
              <label [(ngModel)]="selectedParts[part[1].trim()]" class="skiptranslate" nz-checkbox>
                {{ part[0] }}
              </label>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
      <button nz-button nzType="primary" nzSize="large" class="skiptranslate" (click)="find()">
        {{ 'PARTS.FIND' | translate }}
      </button>
    </section>
  </nz-page-header-content>
</nz-page-header>
